import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(auth)/motdepasseoublie/page.tsx");
